var _g, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFileApproved(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 40,
    viewBox: "0 0 37 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_640_7917)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.8001 0H4.18873C1.87899 0 0 1.80265 0 4.01855V35.9815C0 38.1973 1.87899 40 4.18873 40H26.8113C29.121 40 31 38.1973 31 35.9815V10.4189L18.8001 0ZM19.431 3.15301L27.3098 9.88205H21.5847C20.3976 9.88205 19.431 8.95469 19.431 7.81583V3.15301ZM26.8113 38.0477H4.18873C3.00164 38.0477 2.03501 37.1203 2.03501 35.9815V4.01855C2.03501 2.87969 3.00164 1.95233 4.18873 1.95233H17.396V7.81583C17.396 10.0317 19.2749 11.8344 21.5847 11.8344H28.965V35.9815C28.965 37.1203 27.9984 38.0477 26.8113 38.0477Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 23.3305L23.6973 29L36 16",
    stroke: "#FCE72D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_640_7917"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 40,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileApproved);
export default __webpack_public_path__ + "static/media/File-approved.b129e30d2b8b3c407f9a32f13b205362.svg";
export { ForwardRef as ReactComponent };